export default __webpack_public_path__ + "static/media/04.9215d543.jpg";